// @module C3.ShoppingExtensions.NewsletterSignup
define('C3.ShoppingExtensions.NewsletterSignupPage.MobilePreferences.View'
,	[
	'c3_shoppingextensions_newslettersignuppage_mobile.tpl'
	,   'C3.ShoppingExtensions.NewsletterSignup.Countries.View'
	,   'C3.ShoppingExtensions.NewsletterSignup.States.View'
    ,	'Backbone'
    ,   'Profile.Model'
    ,   'Backbone.FormView'
    ,   'Backbone.CompositeView'
    ,   'C3.ShoppingExtensions.NewsletterSignup.Model'
    ,   'Utils'
    ]
, function (
	c3_shoppingextensions_newslettersignuppage_mobile_tpl
	,   CountriesView
    ,   StatesView
	,	Backbone
	,   ProfileModel
    ,   BackboneFormView
    ,   BackboneCompositeView
    ,   NewsletterSignupModel
    ,   Utils
)
{
    'use strict';

	// @class C3.ShoppingExtensions.NewsletterSignup.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_newslettersignuppage_mobile_tpl

	,   attributes: {
	        id: 'newsletter-signup-mobilepage2'
	    }	

	,	initialize: function (options) {
			this.options = options;
            this.application = options.application;
			this.countries = this.application.configuration.get('siteSettings.countries', []);

            this.userEmail = options.userEmail;
            this.userId = options.userId;
            this.productInterests = options.productInterests;

            var profile = ProfileModel.getInstance()
            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'


            this.model = options.model || new NewsletterSignupModel();

            //BackboneCompositeView.add(this);
            BackboneFormView.add(this);
		}

	,	events: {
		 'submit form': 'submitForm',
         'change [data-action="product-interests-checked"]': 'subscribeIndividualPI'       
		}

/*	,	bindings: {
        '[name="firstname"]': 'firstname',
        '[name="lastname"]': 'lastname',
        '[name="phone"]': 'phone',
        '[name="email"]': 'email',
        '[name="custentity_destination_country"]': 'custentity_destination_country',
        '[name="custentity_customer_state"]': 'custentity_customer_state'
		}*/

	, 	childViews: {

    }

    ,   submitForm: function(e) {
        e.preventDefault();

         const self = this;
         const data = (jQuery(e.target).closest('form')).serializeObject();

         console.log(data)


         const promise = this.saveForm(e);

         if (promise) {
                promise
                    .fail(function(jqXhr) {
                        console.log(jqXhr.responseJSON)
                        $('.newsletter-alert-placeholder').html("<div class='global-views-message global-views-message-success alert' role='alert'><div>Sorry, subscription cannot be updated. Try again later.</div></div>");
                    })
                    .done(function(res) {
                        console.log(res)
                        if(res.code == 'OK')
                        {
                            $('.newsletter-suscription-form-input#email').val('');
                            $('.newsletter-alert-placeholder').html("<div class='global-views-message global-views-message-success alert' role='alert'><div>You've Successfully updated the Newsletter Subscription.</div></div>");
                        }
                    })
            }
    }

    ,  subscribeIndividualPI: function(e)
        {
            var currentTarget = $(e.currentTarget)
            ,   currentTargetProp = currentTarget.prop('checked')

            if(currentTargetProp == true){
               currentTarget.prop('checked',true);
               currentTarget.attr('value', 'T'); 
            }
            else{
                currentTarget.prop('checked',false);
               currentTarget.attr('value', ''); 
            }
        }

		//@method getContext @return C3.ShoppingExtensions.NewsletterSignup.View.Context
	,	getContext: function getContext()
		{
            var productInterestsArray = this.productInterests
            ,   arthroscopy_enabled = false
            ,   laproscopy_enabled = false
            ,   urology_enabled = false
            ,   gyn_enabled = false
            ,   ent_enabled = false
            ,   orthopedic_enabled = false
            ,   neurology_enabled = false
            ,   visualization_enabled = false
            ,   flexible_endoscopy_enabled = false
            ,   patient_care_enabled = false
            ,   imaging_enabled = false
            ,   surgical_power_enabled = false

            if(productInterestsArray)
            var splitProductInterestsArray = productInterestsArray.split(',')

            //console.log(splitProductInterestsArray)

            if(productInterestsArray){
                 _.each(splitProductInterestsArray,function(pi){
                    if(pi == '1'){
                        arthroscopy_enabled = true;
                    }
                    if(pi == '2'){
                        laproscopy_enabled = true;
                    }
                    if(pi == '3'){
                        urology_enabled = true;
                    }
                    if(pi == '5'){
                        gyn_enabled = true;
                    }
                    if(pi == '6'){
                        ent_enabled = true;
                    }
                    if(pi == '7'){
                        orthopedic_enabled = true;
                    }
                    if(pi == '9'){
                        neurology_enabled = true;
                    }
                    if(pi == '12'){
                        visualization_enabled = true;
                    }
                    if(pi == '14'){
                        flexible_endoscopy_enabled = true;
                    }
                    if(pi == '16'){
                        patient_care_enabled = true;
                    }
                    if(pi == '18'){
                        imaging_enabled = true;
                    }
                    if(pi == '33'){
                        surgical_power_enabled = true;
                    }
                });
            }

            return {
				userEmail : this.userEmail,
                userId : this.userId,
                isPhoneDevice : Utils.isPhoneDevice(),
                arthroscopy_enabled : arthroscopy_enabled,
                laproscopy_enabled : laproscopy_enabled,
                urology_enabled : urology_enabled,
                gyn_enabled : gyn_enabled,
                ent_enabled : ent_enabled,
                orthopedic_enabled : orthopedic_enabled,
                neurology_enabled : neurology_enabled,
                visualization_enabled : visualization_enabled,
                flexible_endoscopy_enabled : flexible_endoscopy_enabled,
                patient_care_enabled : patient_care_enabled,
                imaging_enabled : imaging_enabled,
                surgical_power_enabled : surgical_power_enabled
			};
		}
	});
});
